import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import { ServiceIcon } from 'components/common/ServiceIcon'
import { LazyDiv } from 'components/common/LazyHtml'
import kebabCase from 'lodash/kebabCase'
import * as UI from '../../components/CommonStyles'
import AddToQuoteButton from '../../components/AddToQuoteButton'

const BOTServiceDetails = ({
  serviceDetails: {
    displayName,
    description,
    iconName = '',
    // price,
    skuId,
    quantity = 1
  } = {}
}) =>
  <Wrapper data-at-servicedetails-service={ kebabCase(displayName) }>
    <UI.Title data-at-heading={ kebabCase(displayName) }>{ displayName }</UI.Title>
    <UI.ServiceWrapper centered>
      <ServiceBlock>
        <Media.Desktop>
          <ServiceIcon
            data-at-icon
            iconName={ iconName }
            condition
            float="left"
            margin="0 0 30px -168px"
            larger />
        </Media.Desktop>
        <Media.Mobile>
          <ServiceIcon iconName={ iconName } condition float="left" margin="0 16px 16px 0" larger />
        </Media.Mobile>
        { description && <Description data-html-block content={ description } /> }
        {/* Will not be implemented for phase 1 */}
        {/* { price > 0 && <Price>{`$${price}`}</Price> } */}
        <AddToQuoteButton
          data-at-servicedetails-service-addtoquote
          productInfo={{
            skuId,
            quantity
          }} />
      </ServiceBlock>
    </UI.ServiceWrapper>
  </Wrapper>

BOTServiceDetails.type = 'BOTServiceDetails'

export default BOTServiceDetails

BOTServiceDetails.propTypes = {
  serviceDetails: PropTypes.shape({
    description: PropTypes.string,
    displayName: PropTypes.string,
    iconName: PropTypes.string
    // price: PropTypes.number
  })
}

const Wrapper = styled.div`
  ${Mixin.responsive('padding', '50px 12px 25px', '20px 12px')}
`

const ServiceBlock = styled.div`
  text-align: left;
  ${Media.desktop`
    display: inline-block;
    vertical-align: top;
    width: 50%;
  `}
  ${Mixin.responsive('padding', '30px 12px 30px 180px', '20px 0')}
`
const Description = styled(LazyDiv)`
  ${Mixin.responsive('padding-bottom', '20px', '10px')}

  li {
    list-style-type: disc;
    line-height: 1.5;
  }

  h2 {
    ${Mixin.font.GothamBold(26, 600)}
  }
`

// const Price = styled.div`
//   margin: 0 0 30px;
//   color: ${Theme.colors.sub_grey};
//   ${Mixin.font.OpenSans(14, 600, 19)};
// `
